import axios from 'axios';
import apiClient from './apiClient';
import {
  Session,
  PriceCalculation,
  CalculateEnrollmentPriceRequest,
  EnrollChildrenRequest,
  EnrollmentResponse,
  GetEnrollableSessionsResponse
} from '../types/parentEnrollment';

/**
 * Get sessions available for enrollment
 * @returns Array of enrollable sessions
 */
export const getEnrollableSessions = async (): Promise<Session[]> => {
  try {
    const response = await apiClient.get<GetEnrollableSessionsResponse>(
      '/api/parent/enrollments/sessions'
    );
    return response.data.sessions;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const errorMessage =
        error.response.data.message ||
        error.response.data.error ||
        'Failed to fetch enrollable sessions';
      throw new Error(errorMessage);
    }
    throw new Error('Network error. Please try again later.');
  }
};

/**
 * Calculate enrollment price for multiple children
 * @param data - Calculate price request data
 * @returns Price calculation with discounts applied
 */
export const calculateEnrollmentPrice = async (
  data: CalculateEnrollmentPriceRequest
): Promise<PriceCalculation> => {
  try {
    const response = await apiClient.post<PriceCalculation>(
      '/api/parent/enrollments/calculate-price',
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const errorMessage =
        error.response.data.message ||
        error.response.data.error ||
        'Failed to calculate enrollment price';
      throw new Error(errorMessage);
    }
    throw new Error('Network error. Please try again later.');
  }
};

/**
 * Enroll multiple children in sessions
 * Creates PayPal order for payment
 * @param data - Enrollment request data
 * @returns Enrollment response with PayPal order details
 */
export const enrollChildren = async (
  data: EnrollChildrenRequest
): Promise<EnrollmentResponse> => {
  try {
    const response = await apiClient.post<EnrollmentResponse>(
      '/api/parent/enrollments',
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const errorMessage =
        error.response.data.message ||
        error.response.data.error ||
        'Failed to enroll children';
      throw new Error(errorMessage);
    }
    throw new Error('Network error. Please try again later.');
  }
};
